import { render, staticRenderFns } from "./TeacherRedcord.vue?vue&type=template&id=3f1e4236&scoped=true&"
import script from "./TeacherRedcord.vue?vue&type=script&lang=js&"
export * from "./TeacherRedcord.vue?vue&type=script&lang=js&"
import style0 from "./TeacherRedcord.vue?vue&type=style&index=0&id=3f1e4236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e4236",
  null
  
)

export default component.exports